import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function post(data) {
  const response = await http.postData("/protokol-kemoterapi", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function put(id, data) {
  const response = await http.putData(`/protokol-kemoterapi/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByReg(reg) {
  const response = await http.getData(`/register/${reg}/protokol-kemoterapi`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function getById(id) {
  const response = await http.getData(`/protokol-kemoterapi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function destroy(id) {
  const response = await http.deleteData(`/protokol-kemoterapi/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/protokol-kemoterapi/${id}/pdf`, "_blank");
}

export default {
  post,
  put,
  getByReg,
  getById,
  destroy,
  print,
};
